module.exports = __webpack_public_path__ + "static/img/qrcode.dbc84682.jpg";